import { apiClient } from '../client';
import { withDefaultHandlers } from '../helpers/withDefaultHandlers';
import { IMIDFeeScheduleListDto } from 'src/types/payments';

const BASE_PATH = '/payment/ScheduledService-api/FeeScheduledService-info';

export const apiGetFeeScheduleServices = () =>
    withDefaultHandlers<IMIDFeeScheduleListDto[]>(apiClient.get(BASE_PATH));
